import React from "react";
// import Geidea from "../../../public/Geidea.html"

const HtmlViewer = () => {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="/Geidea.html"
        style={{ width: "100%", height: "100%", border: "none" }}
        title="HTML Viewer"
      />
    </div>
  );
};

export default HtmlViewer;